import { Lookup, SpringRef } from "@react-spring/web";

import { MedicalConfirmationFlowEnum } from "@/components/with-undiagnosed-symptoms";

export type QMedicalProps = {
  metadata?: { ["mgnl:template"]: string } | null;
  defaultDescription?: object | null;
  answerYesDescription?: object | null;
  answerNoDescription?: object | null;
  answerUndiagnosedQuestionDescription?: object | null;
  answerUndiagnosedNoQuestionDescription?: object | null;
  defaultSupportDrawer?: object | null;
  answerYesSupportDrawer?: object | null;
  answerNoSupportDrawer?: object | null;
  trustpilot?: object | null;
  defaultReadMoreButtonText?: string;
  answerYesReadMoreButtonText?: string;
  answerNoReadMoreButtonText?: string;
  alertMessage?: string;
  alertMessagePartner?: { partnerKey: string; text: string }[];
  cancelEditingBtnText?: string;
  newMedicalFlowEnabled: boolean;
  alertMessageUndiagnosed?: string;
  alertMessageUndiagnosedPartner?: { partnerKey: string; text: string }[];
  application?: "quote" | "renewal";
} & Omit<
  QMedicalContainerProps,
  | "questionType"
  | "buttonDisable"
  | "usagePage"
  | "selectedAnswer"
  | "setSelectedAnswer"
>;

export type QMedicalContainerProps = {
  questionType?: MedicalQuestionType;
  questionText?: string;
  questionInfoText?: string;
  ctaButtonText?: string;
  yesCtaButtonText?: string;
  noCtaButtonText?: string;
  buttonDisable?: boolean;
  usagePage: string;
  selectedAnswer: number | null;
  questionTwoSelectedAnswer: number | null;
  setSelectedAnswer: (answerNo: number) => void;
  setQuestionTwoAnswer: (answerNo: number) => void | null;
  onSubmit: (usagePage: string) => void;
  onBack: (usagePage: string) => void;
  ctnBtnLoading?: boolean;
  cancelEditingBtnText?: string;
  finishEditingBtnText?: string;
  isFinishEditing?: boolean;
  removeMedicalConditionModalTitle?: string;
  removeMedicalConditionModalDescription?: string;
  removeMedicalConditionModalDescriptionRenewal?: string;
  removeMedicalConditionModalCTABtnOne?: string;
  removeMedicalConditionModalCTABtnTwo?: string;
  saveQuestionModalTitle?: string;
  saveQuestionModalDescription?: string;
  saveQuestionModalCTABtnOne?: string;
  saveQuestionModalCTABtnTwo?: string;
  isTravelerHasMedicalCondition?: boolean;
  medicalConfirmationPageContent?: boolean;
  ctaRef?: SpringRef<Lookup>;
  formRef?: SpringRef<Lookup>;
  newMedicalFlowEnabled?: boolean;
  medicalConfirmationFlow?: MedicalConfirmationFlowEnum;
  questionInfoTextWithUndiagnosed?: string;
  questionInfoTextWithUndiagnosedOptimizelyTestEnabled?: string;
  undiagnosedQuestionEnabled?: string;
  questionUndiagnosedText?: string;
  questionUndiagnosedInfoText?: string;
  yesUndiagnosedCtaButtonText?: string;
  noUndiagnosedCtaButtonText?: string;
  application?: "quote" | "renewal";
  backToRenewalBtnText?: string;
  nonRoutineTestInfoMessage?: string;
  showInforBox?: () => void;
};

export enum MedicalQuestionType {
  Confirmation = "agreedConfirmation",
  Undiagnosed = "hasUndiagnosedSymptoms",
  Conditions = "agreedHistory",
  Treatments = "agreedTreatments",
  Eligibility = "agreedEligibility",
}
